<script>
import DexContent from '@/views/pool/DexContent';

export default {
  name: 'Uniswap',
  mixins: [DexContent],
  data: () => ({
    dex: 'uniswap',
  }),
};
</script>
